import { useEffect, useState } from "react";
import { Download } from "lucide-react";

// Captures the browser's install prompt and shows a button. Hidden when the
// app is already installed / running standalone or when unsupported.
export default function InstallPWAButton({ className = "", label = "Hent app" }) {
    const [deferred, setDeferred] = useState(null);
    const [installed, setInstalled] = useState(false);

    useEffect(() => {
        const standalone = window.matchMedia?.("(display-mode: standalone)")?.matches
            || window.navigator.standalone === true;
        if (standalone) { setInstalled(true); return; }
        const onPrompt = (e) => { e.preventDefault(); setDeferred(e); };
        const onInstalled = () => { setInstalled(true); setDeferred(null); };
        window.addEventListener("beforeinstallprompt", onPrompt);
        window.addEventListener("appinstalled", onInstalled);
        return () => {
            window.removeEventListener("beforeinstallprompt", onPrompt);
            window.removeEventListener("appinstalled", onInstalled);
        };
    }, []);

    if (installed || !deferred) return null;

    return (
        <button
            type="button"
            data-testid="pwa-install-button"
            onClick={async () => { deferred.prompt(); try { await deferred.userChoice; } catch { /* noop */ } setDeferred(null); }}
            className={`inline-flex items-center justify-center gap-2 text-sm font-semibold ${className}`}
        >
            <Download className="w-4 h-4" /> {label}
        </button>
    );
}
